<template>
  <div class="content-item">
    <h2 class="heading">Card Back Design</h2>
    <p class="text">Select the design you would like to use for the back of the invitation cards</p>
    <div class="radio-group">
      <div class="row">
        <div v-for="card in backCards" :key="card.id" class="col-md-4">
          <div class="radio-item" :class="[card.id === selected.id && 'selected']">
            <div class="hoverClass">
              <a-button type="primary" class="h-auto mr-1" @click="doSetCardSelected(card)" shape="circle" icon="check"></a-button>
              <a-button class="h-auto btn-success" @click="doSelectCard(card)" shape="circle" icon="eye"></a-button>
            </div>
            <input type="radio" name="radio-step2" :id="`radio2-step${card.id}`" :checked="card.id === selected.id" />
            <label :for="`radio2-step${card.id}`">
              <img :src="card.url" :alt="card.name" />
              <!-- <span class="font-size-14">{{ card.name }}</span> -->
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get, debounce, isFunction } from 'lodash';
import { empty } from '@/utils';
export default {
  name: 'Step2',
  props: {
    value: {
      type: Object,
    },
    source: {
      type: Object,
    },
    step: {
      type: Number,
    },
  },
  data() {
    return {
      selected: {},
    };
  },
  computed: {
    backCards() {
      return get(this.source, 'back', []);
    },
    isError() {
      return empty(this.selected.id);
    },
  },
  watch: {
    isError: {
      handler(value) {
        if (isFunction(this.doEmitErrorDebouned)) {
          this.doEmitErrorDebouned(value);
        } else {
          this.doEmitError(value);
        }
      },
      immediate: true,
    },
  },
  created() {
    this.doEmitErrorDebouned = debounce(this.doEmitError, 400);
  },
  methods: {
    doSelectCard(card) {
      this.$emit('onSelectCard', card);
    },
    doSetCardSelected(card) {
      this.selected = card;
      setTimeout(() => {
        this.$emit('onNextPage', true);
      }, 500);
    },
    submit() {
      if (this.isError) {
        this.$emit('onAnimated', [this.isError, this.step, 'Card Back is required.']);
      } else {
        this.$emit('input', {
          ...this.value,
          card_back: this.selected.id,
        });
      }
    },
    doEmitError(value) {
      this.$emit('onInvalid', [value, this.step, 'Card Back is required.']);
    },
  },
};
</script>
